import { createReducer, on } from '@ngrx/store';
import { PreQualState } from '../../models/prequal.model';
import * as PreQualActions from './prequal.actions';

export const initialPreQualState: PreQualState = {
  applications: [],
  currentApplication: null,
  loading: false,
  submitting: false,
  error: null,
  success: false,
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0
};

export const prequalReducer = createReducer(
  initialPreQualState,
  on(PreQualActions.submitPreQualApplication, state => ({
    ...state,
    submitting: true,
    error: null,
    success: false
  })),
  on(PreQualActions.submitPreQualApplicationSuccess, (state, { application }) => ({
    ...state,
    submitting: false,
    currentApplication: application,
    success: true,
    error: null
  })),
  on(PreQualActions.submitPreQualApplicationFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    success: false,
    error
  })),
  on(PreQualActions.getPreQualApplications, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(PreQualActions.getPreQualApplicationsSuccess, (state, { page }) => ({
    ...state,
    loading: false,
    applications: page.result,
    pageNumber: page.pageNumber,
    pageSize: page.pageSize,
    totalRecords: page.totalRecords,
    error: null
  })),
  on(PreQualActions.getPreQualApplicationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(PreQualActions.getPreQualApplicationById, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(PreQualActions.getPreQualApplicationByIdSuccess, (state, { application }) => ({
    ...state,
    loading: false,
    currentApplication: application,
    error: null
  })),
  on(PreQualActions.getPreQualApplicationByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(PreQualActions.resetPreQualState, () => initialPreQualState)
);